export const inCartModelIds = ({ inCartModels }) => inCartModels.indexIds;

export const inCartBodyStyleIdsBySeries = ({ inCartModels }, { seriesId }) => {
  let ids = Object.values(inCartModels.byId)
    .filter(model => model.seriesId === seriesId)
    .map(model => model.bodyStyleId);

  return [...new Set(ids)]; // return unique list
};

export const inCartModelIdsByBodyStyle = ({ inCartModels }, { bodyStyleId }) =>
  Object.values(inCartModels.byId)
    .filter(model => model.bodyStyleId === bodyStyleId)
    .map(model => model.id);

export const modelNameByTemplateId = (
  { inCartModels, inCartTemplates },
  { templateId },
) => {
  const modelId = inCartTemplates.byId[templateId].modelId;
  return inCartModels.byId[modelId].description;
};
